<div class="flex h-full overflow-x-auto">
  <app-detail-sidebar
    *ngIf="sidebar?.length"
    [sidebarVisible]="!isItemCollapsed(sidebarKey)"
    [loading]="sidebarLoading"
    (sidebarVisibleChange)="handleToggleSidebar.emit($event)"
    (hoverSidebar)="handleHoverSidebar($event)"
    class="w-min">
    <ng-template #sidebarContent>
      <div *ngFor="let sidebarMenu of sidebar; let isLast = last">
        <app-collapsible-menu
          [title]="sidebarMenu.title"
          [toggleable]="true"
          [collapsed]="isItemCollapsed(sidebarMenu?.title)"
          [loading]="false"
          [config]="sidebarMenu"
          [checkedItems]="checkedItems"
          [itemClass]="'px-0! py-1!'"
          (itemClick)="handleActionClick.emit($event)"
          (collapsedChange)="handleUpdateSidebar(sidebarMenu.title)">
        </app-collapsible-menu>
        <p-divider *ngIf="!isLast"></p-divider>
      </div>
    </ng-template>
  </app-detail-sidebar>

  <div
    [id]="scrollContainerId"
    class="flex w-full flex-col overflow-auto bg-gray-100"
    [ngClass]="{
      'content-margin-left': sidebarHovered()
    }">
    <app-detail-header
      [data]="header"
      [editable]="false"
      [loading]="headerLoading"
      [scrollContainerId]="scrollContainerId">
      <ng-template #actionbarContent>
        <div *ngIf="primaryActions" class="flex flex-wrap gap-2 py-2">
          <app-detail-action-buttons
            [items]="primaryActions"
            [checkedItems]="checkedItems"
            [buttonType]="'button'"
            [checkedItems]="checkedItems"
            class="flex flex-wrap gap-2"
            (itemClick)="handleActionClick.emit($event)"
            (endAction)="handleEndAction.emit($event)"></app-detail-action-buttons>
        </div>
      </ng-template>
      <ng-template #extraOptionsContent>
        <ng-container *ngTemplateOutlet="extraOptionsContentTpl"></ng-container>
      </ng-template>
    </app-detail-header>
    <ng-template [ngTemplateOutlet]="mainContentTpl"></ng-template>
  </div>
</div>
